import { Pipe, PipeTransform } from '@angular/core';
/*
 * Returns true when a given array of objects includes an object with the given ID.
 */
@Pipe({
    name: 'idsFromObjectArray', pure: true,
    standalone: false
})
export class IdsFromObjectArrayPipe implements PipeTransform {
  constructor() {}
  transform(array: { id: string }[] = []): string[] {
    return array.filter((value) => !!value?.id).map((value) => value.id);
  }
}
